import {Pipe, PipeTransform} from '@angular/core';
import {LocalizedText} from '@app/model/equipment.model';
import {LocalizeService} from '@app/service/localize.service';

@Pipe({
	name: 'localize'
})
export class LocalizePipe implements PipeTransform {

	constructor(private localizeService: LocalizeService) {
	}

	transform(localizedText?: LocalizedText | undefined): string {
		if(!localizedText) {
			return '';
		}

		return this.localizeService.localize(localizedText);
	}
}
